import { CatalogosPlataformaService } from "../../generated/grpc/plataforma_catalogos_pb";
import { ProductoResponse } from "../../response/catalogos/ProductoResponse";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Catálogo de productos agroquímicos (gRPC-Web `CatalogosPlataformaService.ListProductos`). Lista cacheada en memoria toda la sesión (catálogo de solo lectura); dos
 *  llamadas simultáneas comparten el mismo request. */
export class ProductoListService {
  static readonly instance = new ProductoListService();
  private constructor() {}

  private _cache: ProductoResponse[] | null = null;
  private _inflight: Promise<ProductoResponse[]> | null = null;

  /** Lista completa (el servidor ya la manda sin eliminados y ordenada). */
  async get(): Promise<ProductoResponse[]> {
    if (this._cache) return this._cache;
    if (this._inflight) return this._inflight;
    this._inflight = grpcCall(() => grpcClient(CatalogosPlataformaService).listProductos({}))
      .then((response) => {
        this._cache = response.items.map((p) => ({
          id: p.id,
          isEliminado: false,
          numeroRegistro: p.numeroRegistro,
          categoria: p.categoria,
          tipo: p.tipo,
          descripcion: p.descripcion,
          unidadMedida: p.unidadMedida,
          tipoFormulacion: p.tipoFormulacion,
          empresa: p.empresa,
          ingredienteActivo: p.ingredienteActivo,
        }));
        return this._cache;
      })
      .finally(() => {
        this._inflight = null;
      });
    return this._inflight;
  }
}
